@if (isOpen) {
  <bic-popup (close)="closePopup()" [hasBackdrop]="true" title="Abo-Info" customClass="max-h-[90vh] overflow-y-auto">
    <div bicPopupContent class="flex flex-col gap-4 font-normal w-[450px]">
      <div class="flex flex-col gap-3 border rounded-md p-3 text-xs">
        <div class="flex flex-row justify-between">
          <div class="text-sm font-medium">Ihr Abo</div>
          <div class="flex flex-row gap-2 items-center">
            <div class="text-sm font-medium">{{ activeProduct.name }}</div>
            <bic-badge>{{ isYearly ? 'Jährlich' : 'Monatlich' }}</bic-badge>
          </div>
        </div>
        <div class="flex flex-row justify-between">
          <div>Organisation</div>
          <div class="flex flex-row gap-2 items-center text-gray-400">
            <div>{{ organisationName }}</div>
          </div>
        </div>
        <div class="flex flex-row justify-between">
          <div>Aktueller Zeitraum</div>
          <div class="flex flex-row gap-2 items-center text-gray-400">
            <div>{{ contingent.currentPeriodStart | date }} - {{ contingent.currentPeriodEnd | date }}</div>
          </div>
        </div>
        <div class="flex flex-row justify-between">
          <div>Verfügbare Prüfungen</div>
          <div class="flex flex-row gap-2 items-center text-gray-400">
            <!-- contingent.myChecks liefert in der Testphase automatisch den Trial-Zähler. -->
            <div>{{ contingent.myChecks }} / {{ totalChecks }}</div>
          </div>
        </div>
        @if (addOnCredits > 0) {
          <!--
            Zusätzlich erworbenes Guthaben. Steht bewusst getrennt vom Abo-Zeitraum darüber:
            es hängt nicht am Zyklus und verfällt nicht.
          -->
          <div class="flex flex-row justify-between">
            <div>Zusätzliches Guthaben</div>
            <div class="flex flex-row gap-2 items-center text-gray-400">
              <div>{{ addOnCredits }} Credits · verfällt nicht</div>
            </div>
          </div>
        }
      </div>

      <!-- Mengenmaessige Grenzen des Abos. Bewusst getrennt von "Verbleibende Nutzungen" darunter:
           dort geht es um Guthaben, das sich verbraucht und je Zyklus neu kommt. Hier geht es um
           Bestaende - angelegte Vorlagen und belegten Speicher. Beides gilt fuer den GANZEN
           Mandanten, nicht fuer das gerade ausgewaehlte Projekt.

           Die Zeilen sind nicht mehr handgeschrieben, sondern kommen aus der Liste des Endpunkts:
           kommt im Backend eine Grenze dazu, erscheint sie hier ohne Aenderung an diesem Template.
           Ist die Liste leer (kein Zugriff, kein Kontingent), faellt der Block samt Ueberschrift
           weg - eine Ueberschrift ueber nichts wirft nur Fragen auf. -->
      @if (limitRows.length > 0) {
        <div class="text-sm font-medium">Begrenzungen</div>
        <div class="flex flex-col gap-3 border rounded-md p-3 text-xs">
          @for (row of limitRows; track row.key) {
            <div class="flex flex-col gap-1">
              <div class="flex flex-row justify-between">
                <div class="flex flex-row gap-1 items-baseline">
                  <div>{{ row.label }}</div>
                  @if (row.sourceLabel) {
                    <!-- Nur bei Abweichung vom Plan sichtbar: sonst passt die Zahl scheinbar nicht
                         zum Abo darueber und niemand kann sich erklaeren, woher sie kommt. -->
                    <div class="text-[10px] text-gray-400">· {{ row.sourceLabel }}</div>
                  }
                </div>
                <div class="text-gray-400">{{ row.valueLabel }}</div>
              </div>
              @if (row.hasLimit) {
                <div class="w-full bg-gray-200 rounded-full h-1.5 overflow-hidden">
                  <div [class]="row.tight ? 'bg-red-500' : 'bg-green-500'"
                       [style.width.%]="row.percent"
                       class="h-1.5 rounded-full transition-all duration-300"></div>
                </div>
                <div class="text-gray-400">{{ row.remainingLabel }}</div>
              }
            </div>
          }
        </div>
      }

      <div class="text-sm font-medium">Verbleibende Nutzungen</div>
      <div class="flex flex-col gap-3 border rounded-md p-3 text-xs">
        <div class="flex flex-row justify-between">
          <div class="text-sm font-medium">Module</div>
          <div class="flex flex-row gap-2 items-end text-gray-900">
            <div class="w-20 text-center text-xs font-medium">Nutzung</div>
            <div class="w-20 text-center text-xs font-medium">Prüfungen</div>
          </div>
        </div>
        <div class="flex flex-row justify-between">
          <div>All-In HOAI-Check</div>
          <div class="flex flex-row gap-2 items-end text-gray-400">
            <div class="w-20 text-center">{{ numberOfChecks(contingent.hoaiCosts) }}x</div>
            <div class="w-20 text-center">{{ asChecks(contingent.hoaiCosts) }}</div>
          </div>
        </div>
        <div class="flex flex-row justify-between">
          <div>All-In LOI-Check</div>
          <div class="flex flex-row gap-2 items-end text-gray-400">
            <div class="w-20 text-center">{{ numberOfChecks(contingent.loiCosts) }}x</div>
            <div class="w-20 text-center">{{ asChecks(contingent.loiCosts) }}</div>
          </div>
        </div>
        <div class="flex flex-row justify-between">
          <div>All-Right-Check</div>
          <div class="flex flex-row gap-2 items-end text-gray-400">
            <div class="w-20 text-center">{{ numberOfChecks(contingent.qualityCosts) }}x</div>
            <div class="w-20 text-center">{{ asChecks(contingent.qualityCosts) }}</div>
          </div>
        </div>
        <div class="flex flex-row justify-between">
          <div>chatBIC</div>
          <div class="flex flex-row gap-2 items-end text-gray-400">
            <div class="w-20 text-center">unbegrenzt</div>
            <div class="w-20 text-center">-</div>
          </div>
        </div>
      </div>

      <div class="text-sm font-medium">Verbrauchshistorie</div>

      <div class="flex flex-col gap-3 border rounded-md p-3 text-xs grow">
        <div class="flex flex-row justify-between">
          <div class="text-sm font-medium">Module</div>
          <div class="flex flex-row gap-2 items-end text-gray-900">
            <div class="w-20 text-center text-xs font-medium">Prüfungen</div>
            <div class="w-20 text-center text-xs font-medium">Datum</div>
          </div>
        </div>
        <div class="flex flex-col gap-2 max-h-52 overflow-y-auto">
          @for (check of checks; track check.id) {
            <div class="flex flex-row justify-between">
              <div>{{ check.checkType! | checkType }}</div>
              <div class="flex flex-row gap-2 items-end text-gray-400">
                <div class="w-20 text-center">{{ asChecks(check.costs) }}</div>
                <div class="w-20 text-center">{{ check.checkDate! | date: "dd.MM.yyyy" }}</div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>

    <div bicPopupButtonGroup class="flex flex-row justify-end gap-4">
      <bic-button (onClick)="closePopup()" buttonType="white">
        Schließen
      </bic-button>
    </div>
  </bic-popup>

}
